"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var ReportsApi = /** @class */ (function (_super) {
    __extends(ReportsApi, _super);
    function ReportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a CSV report asynchronously. The status of the CSV generation and the CSV itself (once available) can be found either in the \'Reports\' section of Spotify Ads Manager or from the Get Async Report endpoint.
     * Create a CSV Report Asynchronously
     */
    ReportsApi.prototype.createAsyncReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAsyncReport.');
                        }
                        if (requestParameters.createAsyncReportRequest === null || requestParameters.createAsyncReportRequest === undefined) {
                            throw new runtime.RequiredError('createAsyncReportRequest', 'Required parameter requestParameters.createAsyncReportRequest was null or undefined when calling createAsyncReport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/async_reports".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateAsyncReportRequestToJSON)(requestParameters.createAsyncReportRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateAsyncReportResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a CSV report asynchronously. The status of the CSV generation and the CSV itself (once available) can be found either in the \'Reports\' section of Spotify Ads Manager or from the Get Async Report endpoint.
     * Create a CSV Report Asynchronously
     */
    ReportsApi.prototype.createAsyncReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAsyncReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns aggregated ad campaign metrics based on requested fields and dimensions.
     * Get Aggregate Report by Ad Account ID
     */
    ReportsApi.prototype.getAggregateReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAggregateReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.entityType !== undefined) {
                            queryParameters['entity_type'] = requestParameters.entityType;
                        }
                        if (requestParameters.fields) {
                            queryParameters['fields'] = requestParameters.fields.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.reportStart !== undefined) {
                            queryParameters['report_start'] = requestParameters.reportStart.toISOString();
                        }
                        if (requestParameters.reportEnd !== undefined) {
                            queryParameters['report_end'] = requestParameters.reportEnd.toISOString();
                        }
                        if (requestParameters.granularity !== undefined) {
                            queryParameters['granularity'] = requestParameters.granularity;
                        }
                        if (requestParameters.includeParentEntity !== undefined) {
                            queryParameters['include_parent_entity'] = requestParameters.includeParentEntity;
                        }
                        if (requestParameters.sourceType !== undefined) {
                            queryParameters['source_type'] = requestParameters.sourceType;
                        }
                        if (requestParameters.sourceId !== undefined) {
                            queryParameters['source_id'] = requestParameters.sourceId;
                        }
                        if (requestParameters.entityIds) {
                            queryParameters['entity_ids'] = requestParameters.entityIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIdsType !== undefined) {
                            queryParameters['entity_ids_type'] = requestParameters.entityIdsType;
                        }
                        if (requestParameters.entityStatusType !== undefined) {
                            queryParameters['entity_status_type'] = requestParameters.entityStatusType;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = requestParameters.statuses.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.continuationToken !== undefined) {
                            queryParameters['continuation_token'] = requestParameters.continuationToken;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/aggregate_reports".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AggregateReportResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns aggregated ad campaign metrics based on requested fields and dimensions.
     * Get Aggregate Report by Ad Account ID
     */
    ReportsApi.prototype.getAggregateReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAggregateReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the status of a CSV report and its download URL (once available). The `report_id` can be found in the response from calling the Create Async Report endpoint.
     * Get CSV Report Status by ID
     */
    ReportsApi.prototype.getAsyncReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAsyncReport.');
                        }
                        if (requestParameters.reportId === null || requestParameters.reportId === undefined) {
                            throw new runtime.RequiredError('reportId', 'Required parameter requestParameters.reportId was null or undefined when calling getAsyncReport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/async_reports/{report_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("report_id", "}"), encodeURIComponent(String(requestParameters.reportId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AsyncReportResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the status of a CSV report and its download URL (once available). The `report_id` can be found in the response from calling the Create Async Report endpoint.
     * Get CSV Report Status by ID
     */
    ReportsApi.prototype.getAsyncReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsyncReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns ad campaign metrics broken out by audience (i.e., targeting) insights based on requested fields and dimensions.
     * Get Insight Report by Ad Account ID
     */
    ReportsApi.prototype.getAudienceInsightReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAudienceInsightReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.insightDimension !== undefined) {
                            queryParameters['insight_dimension'] = requestParameters.insightDimension;
                        }
                        if (requestParameters.fields) {
                            queryParameters['fields'] = requestParameters.fields.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIds) {
                            queryParameters['entity_ids'] = requestParameters.entityIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIdsType !== undefined) {
                            queryParameters['entity_ids_type'] = requestParameters.entityIdsType;
                        }
                        if (requestParameters.entityStatusType !== undefined) {
                            queryParameters['entity_status_type'] = requestParameters.entityStatusType;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = requestParameters.statuses.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/insight_reports".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudienceInsightResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns ad campaign metrics broken out by audience (i.e., targeting) insights based on requested fields and dimensions.
     * Get Insight Report by Ad Account ID
     */
    ReportsApi.prototype.getAudienceInsightReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAudienceInsightReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a superset of aggregated ad campaign metrics based on requested fields and dimensions to be used in the UI.
     * Get Internal Aggregate Report by Ad Account ID
     */
    ReportsApi.prototype.getInternalAggregateReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getInternalAggregateReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.entityType !== undefined) {
                            queryParameters['entity_type'] = requestParameters.entityType;
                        }
                        if (requestParameters.fields) {
                            queryParameters['fields'] = requestParameters.fields.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.measurementFields) {
                            queryParameters['measurement_fields'] = requestParameters.measurementFields.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.reportStart !== undefined) {
                            queryParameters['report_start'] = requestParameters.reportStart.toISOString();
                        }
                        if (requestParameters.reportEnd !== undefined) {
                            queryParameters['report_end'] = requestParameters.reportEnd.toISOString();
                        }
                        if (requestParameters.granularity !== undefined) {
                            queryParameters['granularity'] = requestParameters.granularity;
                        }
                        if (requestParameters.includeParentEntity !== undefined) {
                            queryParameters['include_parent_entity'] = requestParameters.includeParentEntity;
                        }
                        if (requestParameters.sortType !== undefined) {
                            queryParameters['sort_type'] = requestParameters.sortType;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.entityIds) {
                            queryParameters['entity_ids'] = requestParameters.entityIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIdsType !== undefined) {
                            queryParameters['entity_ids_type'] = requestParameters.entityIdsType;
                        }
                        if (requestParameters.entityStatusType !== undefined) {
                            queryParameters['entity_status_type'] = requestParameters.entityStatusType;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = requestParameters.statuses.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityName !== undefined) {
                            queryParameters['entity_name'] = requestParameters.entityName;
                        }
                        if (requestParameters.continuationToken !== undefined) {
                            queryParameters['continuation_token'] = requestParameters.continuationToken;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.sourceType !== undefined) {
                            queryParameters['source_type'] = requestParameters.sourceType;
                        }
                        if (requestParameters.sourceId !== undefined) {
                            queryParameters['source_id'] = requestParameters.sourceId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/internal_aggregate_reports".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.InternalAggregateReportsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a superset of aggregated ad campaign metrics based on requested fields and dimensions to be used in the UI.
     * Get Internal Aggregate Report by Ad Account ID
     */
    ReportsApi.prototype.getInternalAggregateReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInternalAggregateReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Internal-only endpoint to returns ad campaign metrics broken out by audience (i.e., targeting) insights based on requested fields and dimensions.
     * Get Internal Insight Report by Ad Account ID
     */
    ReportsApi.prototype.getInternalAudienceInsightReportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getInternalAudienceInsightReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.internalInsightDimension !== undefined) {
                            queryParameters['internal_insight_dimension'] = requestParameters.internalInsightDimension;
                        }
                        if (requestParameters.fields) {
                            queryParameters['fields'] = requestParameters.fields.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIds) {
                            queryParameters['entity_ids'] = requestParameters.entityIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.entityIdsType !== undefined) {
                            queryParameters['entity_ids_type'] = requestParameters.entityIdsType;
                        }
                        if (requestParameters.entityStatusType !== undefined) {
                            queryParameters['entity_status_type'] = requestParameters.entityStatusType;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = requestParameters.statuses.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/internal_insight_reports".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.InternalAudienceInsightResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Internal-only endpoint to returns ad campaign metrics broken out by audience (i.e., targeting) insights based on requested fields and dimensions.
     * Get Internal Insight Report by Ad Account ID
     */
    ReportsApi.prototype.getInternalAudienceInsightReport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInternalAudienceInsightReportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ReportsApi;
}(runtime.BaseAPI));
exports.ReportsApi = ReportsApi;
